import { mainApi } from '../../../../api/mainApi';

import { middlewareApi } from '../../../middleware/middlewareApi';

import { AccessState } from '../../../../types';
import { IResponse } from '../../../shared/interfaces/response.interface';
import { PosgraduatePlanningHourhand } from '../interfaces/posgraduatePlanningHourhands.interface';

export const posgraduatePlanningHourhandsTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['PostgraduatePlanningHourhands'],
});
// Define a service using a base URL and expected endpoints
export const posgraduatePlanningHourhandsApi = posgraduatePlanningHourhandsTags.injectEndpoints({
  // overrideExisting: false,

  endpoints: (builder) => ({
    getPosgraduatePlanningHourhands: builder.query<
      IResponse<PosgraduatePlanningHourhand>,
      {
        profileId?: number;
        page: number;
        perPage: number;
        search: string;
        sort?: string;
        type_sort?: string;
        modalityId?: number;
      }
    >({
      queryFn: async (
        { profileId, page, perPage, search, sort, type_sort, modalityId },
        { dispatch, getState }
      ) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.get<IResponse<PosgraduatePlanningHourhand>>(
            `/offer-modality-hourhand-education-levels`,
            {
              params: {
                user_profile_id,
                page,
                size: perPage,
                search,
                ...(sort && { sort }),
                ...(type_sort && { type_sort }),
                ...(modalityId && { modality_id: modalityId }),
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [
        {
          type: 'PostgraduatePlanningHourhands',
          id: 'TABLE',
        },
      ],
    }),

    getPosgraduatePlanningHourhand: builder.query<
      PosgraduatePlanningHourhand,
      {
        id: string;
        profileId: number;
      }
    >({
      queryFn: async ({ id, profileId }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.get<PosgraduatePlanningHourhand>(
            `/offer-modality-hourhand-education-levels/${id}`,
            {
              params: {
                user_profile_id,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [
        {
          type: 'PostgraduatePlanningHourhands',
          id: 'TABLE',
        },
      ],
    }),

    addPosgraduatePlanningHourhand: builder.mutation<
      any,
      {
        profileId: number;
        modalityId: number;
        hourhandId: number;
      }
    >({
      queryFn: async ({ modalityId, hourhandId }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.post<any>(`/offer-modality-hourhand-education-levels`, {
            user_profile_id,
            off_description: 'oferta_postgrado',
            modality_id: modalityId,
            hourhand_id: hourhandId,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        {
          type: 'PostgraduatePlanningHourhands',
          id: 'TABLE',
        },
      ],
    }),
    updatePosgraduatePlanningHourhand: builder.mutation<
      any,
      {
        profileId: number;
        id: string;
        modalityId: number;
        hourhandId: number;
      }
    >({
      queryFn: async ({ id, modalityId, hourhandId }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.put<any>(
            `/offer-modality-hourhand-education-levels/${id}`,
            {
              user_profile_id,
              off_description: 'oferta_postgrado',
              modality_id: modalityId,
              hourhand_id: hourhandId,
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        {
          type: 'PostgraduatePlanningHourhands',
          id: 'TABLE',
        },
      ],
    }),

    deletePosgraduatePlanningHourhand: builder.mutation<
      any,
      {
        profileId: number;
        id: string;
      }
    >({
      queryFn: async ({ id }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.delete<any>(
            `/offer-modality-hourhand-education-levels/${id}`,
            {
              params: {
                user_profile_id,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        {
          type: 'PostgraduatePlanningHourhands',
          id: 'TABLE',
        },
      ],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPosgraduatePlanningHourhandsQuery,
  useLazyGetPosgraduatePlanningHourhandQuery,
  useAddPosgraduatePlanningHourhandMutation,
  useUpdatePosgraduatePlanningHourhandMutation,
  useDeletePosgraduatePlanningHourhandMutation,
} = posgraduatePlanningHourhandsApi;
